import { FieldBuilder, FieldDefinition } from '@zendra/shared';
import { PropertyService, RegisterService, StandService } from 'cbd-proxies';

FieldBuilder.setNamespace('Planning');

export const STANDPERREGISTER_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'standId',
    'Entity.Stand',
    StandService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'registerId',
    'Entity.Register',
    RegisterService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .number('standRegisterArea', 'Entity.StandPerRegister.StandRegisterArea')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('standAreaPercentage', 'Entity.StandPerRegister.StandAreaPercentage')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('registerAreaPercentage', 'Entity.StandPerRegister.RegisterAreaPercentage')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .checkbox('isMainRegister', 'Entity.StandPerRegister.IsMainRegister')
    .build(),
  FieldBuilder
    .checkbox('isLastRegister', 'Entity.StandPerRegister.IsLastRegister')
    .build(),
  FieldBuilder
    .checkbox('isStandPerRegisterAvailableInGis', 'Entity.StandPerRegister.IsStandPerRegisterAvailableInGis')
    .build(),
  FieldBuilder.foreignKey(
    'propertyId',
    'Entity.Property',
    PropertyService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const STANDPERREGISTER_CONFIG = {
  entityName: 'StandPerRegister',
  localizationKey: 'Planning::Entity.StandPerRegister',
  fields: STANDPERREGISTER_FIELDS,
  permission: 'PlanningGeography.StandPerRegisters',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
